import React from 'react';
import "./home.css";
import logo from "../../assets/logos/logo.png";

const Home = ({ customerID }) => {
  return (

    <div className="home">

      <div className="home-body">

        <div className="home-body-left">
          <img src={logo} className="home-body-left-img" alt='Logo' />
        </div>

        <div className="home-body-right">
          <p className="home-body-right-p1">
            Im Folgenden hast du auf Basis eines wissenschaftlich entwickelten und validen Analyse- und Messverfahrens die Möglichkeit, ein umfassendes Bild über deine Soft Skills – Fähigkeiten die über erlernte Fach- und Methodenkompetenzen hinausgehen – zu generieren.
          </p>
          <p className="home-body-right-p1">
            Nimm dir 10 Minuten Zeit und beantworte die Fragen so intuitiv und ehrlich wie möglich – es gibt keine falschen Antworten.
            Weder dein Ergebnis noch deine persönlichen Daten werden gespeichert oder automatisch weitergeleitet.
          </p>
          <button onClick={() => { window.location.href = `/fitcheck/${customerID}` }} className="home-body-btn">Start</button>
        </div>

      </div>
    </div>
  )
};

export default Home;